import React, { useState, useEffect } from 'react';
import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import SelectionProvider from './SelectionContext.js'
import { useSelection } from './SelectionContext.js'


function useWindowWidth() {
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
}

const Overlay = () => {
  const { selection, setSelection } = useSelection()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const width = useWindowWidth()
  const isMobile = width <= 600

  const handleNavClick = (section, e) => {
    e.preventDefault()
    setSelection(section)
    setIsMenuOpen(false)
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <>
      <div
        className={`overlay ${selection === 'home' ? 'overlay-home' : ''}`}
        style={{
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: isMobile ? '0.5rem' : undefined,
        }}
      >
        <div style={{ marginLeft: '7%', marginTop: '2%' }}>
          <div
            style={{
              fontFamily: "'Raleway', serif",
              //fontStyle: 'italic',
              fontSize: '1.6rem',
              color: 'black',
              opacity: 0.7,
              whiteSpace: 'nowrap',
            }}
          >
            Kait Fox
          </div>
          <div
            style={{
              fontFamily: "'Raleway', sans-serif",
              fontWeight: 200,
              fontSize: '1.0 rem',
              letterSpacing: '0.2em',
              color: 'black',
              opacity: 0.45,
              marginTop: '4px',
              whiteSpace: 'nowrap',
            }}
          >
            Los Angeles
          </div>
        </div>

        <button
          className="hamburger-btn"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          style={{ marginLeft: 'auto' }}
        >
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
        </button>

        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul>
            <li
              className="nav-link"
              onClick={(e) => handleNavClick('statement', e)}
          >
      
              <a style={{
                  color: 'black',
                 opacity: selection === 'statement' ? 0.35 : 0.95 ,
                  textDecoration: 'none',
                }}
                href="#">
                home
              </a>
            </li>

            <li
              className="nav-link"
              onClick={(e) => handleNavClick('projects', e)}
              >
              <a style={{
                  color: 'black',
                  opacity: selection === 'projects' ? 0.35 : 0.95,
                  textDecoration: 'none',
                }}
                href="#">
                projects
              </a>
            </li>

            <li
              className="nav-link"
              onClick={(e) => handleNavClick('posters', e)}
              >
               <a style={{
                  color: 'black',
                  opacity: selection === 'posters' ? 0.35 : 0.95,
                  textDecoration: 'none',
                }}
                href="#">
                morning pages
              </a>
            </li>

            <li
              className="nav-link"
              onClick={(e) => handleNavClick('photographs', e)}
              >
              <a href="#"
                style={{
                  color: 'black',
                  opacity: selection === 'photographs' ? 0.35 : 0.95,
                  textDecoration: 'none',
                }}>
                photographs
              </a>
            </li>

          </ul>
        </nav>
      </div>

        <div>
          <hr style={{ width: '90%', borderWidth: '2px', opacity: '20%' }} />
        </div>
  
    </>
  )
}

const App = () => {
  return (
    <SelectionProvider>
      <div className="canvas-container">
        <Overlay />
        <Experience />
      </div>
    </SelectionProvider>
  )
}

const root = ReactDOM.createRoot(document.querySelector('#root'))
root.render(<App />)